
function buildEarnTableRows(groups) {
  const rows = [];

  groups.forEach((group) => {
    group.items.forEach((item, index) => {
      rows.push({
        category: group.category,
        showCategory: index === 0,
        categoryRowspan: group.items.length,
        action: item.action,
        coins: item.coins,
        limit: item.limit,
      });
    });
  });

  return rows;
}

const earnTableRows = buildEarnTableRows([
  {
    category: "New User Bonus",
    items: [
      {
        action:
          "First-time registration (including community, online store, and official website channels)",
        coins: "100",
        limit: "One-time",
      },
      {
        action: "First-time email subscription",
        coins: "20",
        limit: "One-time",
      },
    ],
  },
  {
    category: "Sharing Creation",
    items: [
      {
        action: "Successfully published content (works, discussion threads)",
        coins: "10",
        limit: "Up to 4 times per day",
      },
    ],
  },
  {
    category: "Community Interaction",
    items: [
      {
        action: "Like other people's content (works, discussion threads, courses)",
        coins: "1",
        limit: "Up to 10 times per day",
      },
      {
        action: "Comment on other people's content (works, discussion threads, courses)",
        coins: "2",
        limit: "Up to 20 times per day",
      },
      {
        action: "Save other people's content (works, discussion threads, courses)",
        coins: "1",
        limit: "Up to 10 times per day",
      },
    ],
  },
]);

const faqList = [
  {
    question: "Where can I check my X-Coins balance and details?",
    answer:
      "After logging into the community, go to Personal Center → My X-Coins → X-Coins Center to view your current balance, earning history, redemption history, and X-Coins about to expire.",
  },
  {
    question: "Why haven't I earned X-Coins for my posts or works?",
    answer:
      "There may be several reasons: the content is under review; the content violated community guidelines and was rejected; the X-Coins limit for that behavior on the same day has been exceeded. Please check your X-Coins details first.",
  },
  {
    question: "Are there any quantity or frequency limits for X-Coins redemption?",
    answer:
      "Some rewards may have redemption limits or period limits, please refer to the actual display in the X-Coins shop.",
  },
  {
    question: "Can X-Coins be shared or gifted to others?",
    answer:
      "No, X-Coins can only be used in your own account and cannot be transferred or gifted.",
  },
  {
    question:
      "I earn X-Coins by commenting on other people's posts, but will I earn X-Coins if others comment on my posts?",
    answer:
      "No. You only earn X-Coins by actively commenting on other people's content. Commenting on or replying to your own content will not earn X-Coins.",
  },
];

export default {
  name: "xcoinRules",
  layout: "DefaultLayout",
  head() {
    return {
      title: "X-Coins User Guide",
      meta: [
        {
          name: "keywords",
          content: "X-Coins rules",
        },
        {
          name: "description",
          content: "X-Coins user guide and rules",
        },
      ],
    };
  },
  data() {
    return {
      earnTableRows,
      faqList,
    };
  },
};
